// extracted by mini-css-extract-plugin
export default {"AddButton":"AddButton_AddButton__3NNZO","AddButton__icon":"AddButton_AddButton__icon__3J5tg","AddButton__text":"AddButton_AddButton__text__10H95"};